import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
  state: {
    homeDetails: {}
  },
  getters: {
    getHomeDetails: (state) => state.homeDetails
  },
  actions: {
    fetchHomeDetails({ commit }) {
      axios.get(`${BASE_URL}/home`).then((response) => {
        commit("setHomeDetails", response.data.data.old_data_array)
      });
    }
  },
  mutations: {
    setHomeDetails: (state, homeData) => (state.homeDetails = homeData),
  },
};
